import { render } from "./WechatLoginQR.vue?vue&type=template&id=4985c318&scoped=true"
import script from "./WechatLoginQR.vue?vue&type=script&lang=js"
export * from "./WechatLoginQR.vue?vue&type=script&lang=js"

import "./WechatLoginQR.vue?vue&type=style&index=0&id=4985c318&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4985c318"]])

export default __exports__